// extracted by mini-css-extract-plugin
module.exports = {"formDetails":"FormsOverviewListPanel_formDetails__RCtn5","ingress":"FormsOverviewListPanel_ingress___m8xt"};